<template>
  <div>
    <v-row no-gutters> Buttons </v-row>
    <v-row>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-btn color="primaryDark">
                ラベル <v-icon>mdi-chevron-down</v-icon></a-btn
              >
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn color="primaryDark2">
                ラベル <v-icon>mdi-chevron-down</v-icon></a-btn
              >
            </v-row>
            <v-row no-gutters>
              <a-btn color="primaryDark">
                {{ $t("agenda.btnCreateNewAgenda") }}</a-btn
              >
            </v-row>
            <v-row no-gutters class="mb-5">
              <img src="@/assets/Untitled.png" />
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn color="secondary">
                ラベル <v-icon>mdi-chevron-down</v-icon></a-btn
              >
            </v-row>
            <!-- <v-row no-gutters class="mb-5">
              <a-btn color="default_navi">
                ラベル <v-icon>mdi-chevron-down</v-icon></a-btn
              >
            </v-row> -->
            <v-row no-gutters>
              <a-btn class="disabled-button" disabled>
                ラベル <v-icon>mdi-chevron-down</v-icon></a-btn
              >
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-btn color="primaryDark"> ラベル</a-btn>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn color="primaryDark2"> ラベル </a-btn>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn class="disabled-button" disabled> ラベル </a-btn>
            </v-row>
            <v-row no-gutters>
              <a-btn color="secondary"> CLOSE </a-btn>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-btn color="primaryDark" small>
                ラベル <v-icon>mdi-chevron-down</v-icon></a-btn
              >
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn small color="primaryDark2">
                ラベル <v-icon>mdi-chevron-down</v-icon></a-btn
              >
            </v-row>
            <v-row no-gutters>
              <a-btn class="disabled-button" disabled small>
                ラベル <v-icon>mdi-chevron-down</v-icon></a-btn
              >
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-btn color="primaryDark">
                <v-icon>mdi-chevron-down</v-icon> ラベル
              </a-btn>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn color="primaryDark2">
                <v-icon>mdi-chevron-down</v-icon> ラベル</a-btn
              >
            </v-row>
            <v-row no-gutters>
              <a-btn class="disabled-button" disabled>
                <v-icon>mdi-chevron-down</v-icon> ラベル
              </a-btn>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-btn color="primaryDark" small>
                <v-icon>mdi-chevron-down</v-icon> ラベル
              </a-btn>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn small color="primaryDark2">
                <v-icon>mdi-chevron-down</v-icon> ラベル</a-btn
              >
            </v-row>
            <v-row no-gutters>
              <a-btn class="disabled-button" disabled small>
                <v-icon>mdi-chevron-down</v-icon> ラベル</a-btn
              >
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-btn color="primaryDark" small width="32" min-width="32">
                <v-icon size="16"> mdi-help</v-icon>
              </a-btn>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn color="primaryDark" small width="32" min-width="32">
                <v-icon size="16"> mdi-delete</v-icon>
              </a-btn>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn small color="primaryDark2" width="32" min-width="32">
                <v-icon size="16"> mdi-help</v-icon>
              </a-btn>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn
                width="32"
                min-width="32"
                small
                class="disabled-button"
                disabled
              >
                <v-icon size="16"> mdi-help</v-icon>
              </a-btn>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-btn x-small color="secondary" width="24" min-width="24">
                <v-icon size="16" color="neutralGray1"> mdi-pencil</v-icon>
              </a-btn>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <a-btn color="primaryDark" outlined> ラベル</a-btn>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn outlined color="primaryDark2"> ラベル </a-btn>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn outlined color="primaryDark"> ラベル </a-btn>
            </v-row>
            <v-row no-gutters class="mb-5">
              <a-btn disabled outlined> ラベル </a-btn>
            </v-row>
            <v-row no-gutters>
              <a-btn class="disabled-button" disabled> ラベル </a-btn>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
      <v-col cols="auto">
        <div class="card-div">
          <v-card-text>
            <v-row no-gutters class="mb-5">
              <v-btn-toggle
                active-class="toggle-active-class"
                class="a-toggle-button"
              >
                <a-btn value="left">
                  <span class="hidden-sm-and-down">In person</span>
                </a-btn>

                <a-btn value="center">
                  <span class="hidden-sm-and-down">Remotely</span>
                </a-btn>

                <a-btn value="right">
                  <span class="hidden-sm-and-down">Absent</span>
                </a-btn>
              </v-btn-toggle>
            </v-row>
          </v-card-text>
        </div>
      </v-col>
    </v-row>
    
  </div>
</template>

<script>

import ABtn from "./ABtn.vue";
export default {
  components: { ABtn },
  name: "ButtonsSample"
};
</script>

<style scoped>
  .a-toggle-button.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
    border-color: var(--v-primaryDark-base) !important;
  }
</style>